/* eslint-disable react-hooks/exhaustive-deps */

import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import FacilitatorHeader from "../components/facilitator_components/FacilitatorHeader.tsx";
import { useAppSelector } from "../redux/hook.ts";
import VotingService from "../api_handlers/services/VotingService.ts";
import { useToast } from "../components/base_components/ToastContext.tsx";
import TeamList from "../components/facilitator_components/TeamList.tsx";
import SessionService from "../api_handlers/services/SessionService.ts";
import Leaderboard from "../components/facilitator_components/Leaderboard.tsx";
import TeamDetailsDialog from "../components/facilitator_components/teamDetailModal.tsx";
import FacilitatorService from "../api_handlers/services/FacilitatorService.ts";
import GameViewModal from "../components/facilitator_components/gameViewModal.tsx";
import ScoringService from "../api_handlers/services/ScoringService.ts";

interface Team {
  teamName: string;
  totalCredits: number;
  percentage: number;
  teamId: number;
}

interface LeaderboardResponse {
  leaderboard: {
    team: Record<number, Team>; // key is teamId, value is a Team
    teamList: Team[]; // Array of Teams
  };
}

const FacilitatorPage = () => {
  const [teamsWithUsers, setTeamsWithUsers] = useState([]);
  const [leaderboardRows, setLeaderboard] = useState(Array<Team>);
  const [selectedTeamId, setSelectedTeamId] = useState<any>({});
  const [viewGame, setViewGame] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const fSession = useAppSelector((state) => state.fSession.session);
  const { showToast } = useToast();
  const moveToNextTeam = () => {
    VotingService.moveToNextTeam(fSession?.sessionId)
      .then((res) => {
        console.log(res);
        showToast("All teams have been moved to next team");
      })
      .catch((err) => {
        console.log(err);
        showToast(err.response.data, "warning");
      });
  };

  const startVoting = () => {
    VotingService.startVoting(fSession?.sessionId)
      .then((res) => {
        console.log(res);
        showToast("Voting has been started.");
      })
      .catch((err) => {
        console.log(err);
        showToast(err.response.data, "warning");
      });
  };

  const getUsers = () => {
    SessionService.getUsers(fSession?.sessionId)
      .then((res) => {
        if (JSON.stringify(res.data.teams) !== JSON.stringify(teamsWithUsers)) {
          setTeamsWithUsers(res.data.teams);
        }
      })
      .catch((err) => {
        showToast(err.response.data, "warning");
      });
  };

  const getLeaderboard = () => {
    SessionService.getLeaderboard(fSession?.sessionId)
      .then((res: { data: LeaderboardResponse }) => {
        const teams = res.data.leaderboard.teamList; // Directly using teamList from the response
        const teamArray: Team[] = [];
  
        // Iterate over the teamList, as it is already sorted
        teams.forEach(team => {
          teamArray.push({
            teamName: team.teamName,
            totalCredits: team.totalCredits,
            percentage: team.percentage,
            teamId: team.teamId,
          });
        });
  
        // Check if the leaderboard state has changed
        if (JSON.stringify(teamArray) !== JSON.stringify(leaderboardRows)) {
          setLeaderboard(teamArray);
        }
      })
      .catch((err) => {
        //showToast(err.response.data, "warning");
      });
  };
  




  const getCurrentIndex = async () => {
    try {
      const data = await ScoringService.getCurrentIndex({
        sessionId: fSession?.sessionId,
      });
      setCurrentIndex(data.data.index);
    } catch (error) {
      showToast(error.response.data, "warning");
    }
  };

  const moveToNextCollectible = async () => {
    try {
      const data = await FacilitatorService.moveTonextcollectible({
        sessionId: fSession?.sessionId,
      });
      console.log("🚀 ~ moveToNextCollectible ~ data:", data);
      setCurrentIndex(data.data.index);
      showToast("Moved to next collectible");
    } catch (error) {
      showToast(error.response.data, "warning");
    }
  };

  const moveToNext = async (selectedValue: number) => {
    try {
      const data = await FacilitatorService.moveTonext({
        sessionId: fSession?.sessionId,
        index: selectedValue,
      });
      setCurrentIndex(data.data.index);
      showToast(`Moved to ${selectedValue}`);
    } catch (error) {
      showToast(error.response.data, "warning");
    }
  };

  useEffect(() => {
    getLeaderboard();
    getUsers();
    getCurrentIndex();
    const intervalId = setInterval(() => {
      getUsers();
      getLeaderboard();
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Box
      display="flex"
      height="100vh"
      sx={{
        backgroundImage: 'url("/img/team-background/sword.png")',
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box sx={{ mt: 9 }} width="100%">
        <FacilitatorHeader
          moveToNextTeam={moveToNextTeam}
          startVoting={startVoting}
          moveToNextCollectible={moveToNextCollectible}
          setViewGame={setViewGame}
          moveToNext={moveToNext}
        ></FacilitatorHeader>
        <Box display="flex" flexDirection="row">
          <TeamList teams={teamsWithUsers}></TeamList>
          <Leaderboard
            leaderboardRows={leaderboardRows}
            setSelectedTeamId={setSelectedTeamId}
          ></Leaderboard>
        </Box>
      </Box>

      {selectedTeamId && (
        <TeamDetailsDialog
          team={selectedTeamId}
          onClose={() => setSelectedTeamId(null)}
        />
      )}

      <GameViewModal
        open={viewGame}
        onClose={() => setViewGame(false)}
        moveToNextCollectible={moveToNextCollectible}
        moveToPrev={moveToNext}
        currentIndex={currentIndex}
        startVoting={startVoting}
        moveToNextTeam={moveToNextTeam}
      />
    </Box>
  );
};

export default FacilitatorPage;
